import { NgModule } from "@angular/core";

import { NoItemsComponent } from "./no-items.component";

@NgModule({
  imports: [NoItemsComponent],
  exports: [NoItemsComponent],
})
export class NoItemsModule {}
